"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = ({ icon, isV2 }) => {
    const theme = (0, material_1.useTheme)();
    const badgeStyles = Object.assign(Object.assign({}, theme.qlub.typography.button), { height: '24px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: '2px 8px', gap: icon ? '4px' : '10px', background: theme.qlub.palette.caution.main, color: theme.qlub.palette.onSurfaceColors.highEmphasis, borderRadius: isV2 ? '2px' : '100px', textTransform: 'none', textOverflow: 'ellipsis', width: 'max-content' });
    const iconStyles = {
        height: '1rem',
    };
    const labelStyles = Object.assign(Object.assign({ color: theme.qlub.palette.onSurfaceColors.highEmphasis }, theme.qlub.typography.button), { fontFamily: 'inherit', fontSize: isV2 ? '10px' : '14px', fontWeight: '500', lineHeight: '20px', letterSpacing: '0.25px', textAlign: 'center', whiteSpace: 'nowrap' });
    const rtlStyles = {
        'html[dir="rtl"] &': {
            flexDirection: 'row-reverse',
        },
    };
    return {
        badgeStyles,
        iconStyles,
        labelStyles,
        rtlStyles,
    };
};
exports.default = useStyle;
